module.exports = __webpack_public_path__ + "static/book-another-figure-in-the-landscape-4bde9ba3c49727f1a69f2c75aa546b06.jpg";